import {
  IRequestPromoCodeHistory,
  IRequestPromoCodeHistoryData
} from './index'
import {
  RequestPromoCodeStatus
} from '../index'
import {
  IDate,
  History
} from '../../../../abstract'

export class RequestPromoCodeHistory extends History implements IRequestPromoCodeHistory {
  readonly id?: number
  readonly date_creation?: IDate
  status: RequestPromoCodeStatus

  constructor(data?: IRequestPromoCodeHistoryData) {
    super(data)
    this.status = data?.status || 'new'
  }

  validate(): boolean {
    return super.validate()
  }
}
